import { ScorePayload } from '@/types'
import CollectRepository, { ICollectRepository } from './CollectRepository'

export class CollectService {
  private repository: ICollectRepository

  constructor() {
    this.repository = new CollectRepository('collects')
  }

  async getSlots(
    type: string,
    id: string,
    fromDate: string,
    toDate: string,
    language?: string,
  ): Promise<any> {
    const { data } = await this.repository.getSlots(id, {
      fromDate,
      toDate,
      type,
      language,
    })

    return data
  }

  async patchSlot(id: string, params: { slot: { start: string; end: string } }): Promise<any> {
    return await this.repository.patchSlots(id, params)
  }

  async getCollect(id: string, type: string, language?: string): Promise<any> {
    const { data } = await this.repository.getCollect(id, type, language)

    return data
  }

  async patchWaiting(id: string, place: string): Promise<{ status: string; updated: boolean }> {
    const { data } = await this.repository.patchWaiting(id, place)

    return data
  }

  async createScore(id: string, payload: ScorePayload): Promise<void> {
    await this.repository.createScore(id, payload)
  }
}

export default new CollectService()
